import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_c5the2m9ad: FaireBrandEntity = {
  token: "b_c5the2m9ad",
  type: "brand",
  name: "St. Louis Wholesale LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/0a8a1f6e25fa14b29487056a5008069dafd9e9394339ebc16947fe7c2f424c49.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/94d403acd52db8e3ce810b3402dda42e256010c910c9e5aeadc10ccae6c1fcba.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0a8a1f6e25fa14b29487056a5008069dafd9e9394339ebc16947fe7c2f424c49.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/94d403acd52db8e3ce810b3402dda42e256010c910c9e5aeadc10ccae6c1fcba.jpeg",
  location: "St. Louis, MO, USA",
  minimumOrderDollars: 125,
  rating: 4.9,
  reviewCount: 262,
  isTopShop: true,
  isInsider: true,
  description:
    'St. Louis Wholesale LLC. specializes in Off-Price, Liquidation, Imports and Closeouts. Our Main Division is in NFL Merchandise and League Licensed Merchandise.\nIn 2016 we opened Second Division which produces offerings in the General Merchandise Category.\n\nSt. Louis Wholesale LLC was opened in 1999. We started as Sunglass importers and Wholesalers. We developed a large following in this arena. To compensate for downturn sales in the Fall/Winter we developed an NFL Merchandise Product Line.\nSince then, this has grown into a full blown Licensed Merchandise and General Merchandise offering. We pride ourselves on offering new products on a daily basis. We can accomplish this by the Very Strong relationships we have created with major vendors and manufacturers along with our "partners" our customers. We believe strongly that if our partners succeed, we succeed. We work as a team. We work endlessly on securing new products at sharp closeout pricing. This allows us to have continued growth in the industry and allows our partner base to create profit making opportunities with new product assortments.\n\nWe understand Price is the #1 focus in the industry in this day and age. We secure new deals with this in mind on every truckload we bring in. We are constantly buying and selling. Our goal is too offer our partners a wide range of Cost-Effective, High-Quality Merchandise in Licensed and General Arenas.\n',
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:30.441Z",
    importedBy: "entity-db-cli",
  },
};
